// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DevApp__wrapper___33uCx"};